<div id="map-nav" class="bg-light">
  <button type="button" id="map-nav-close-btn" class="btn-close right mt-3 mr-1" aria-label="Close" (click)="sendCloseNavClickToParent()"></button>
  <!-- Default mode START -->
  @if (!msaMode) {
    <div class="pt-3">
      <div [hidden]="!groupping" class="selected-group selected-child">
        <p class="gray-text">{{'planner.mapNav.selectedGroup' | translate }}:</p>
        <h3>{{'planner.mapNav.group' | translate }} {{ groupId }}</h3>
      </div>
      <div class="selected-group selected-child selected-h">
        <p class="gray-text">{{'planner.mapNav.selectedMeter' | translate }}:</p>
      </div>
      <div class="selected-meter selected-child">
        <div [hidden]="meterId == null" [ngStyle]="{'border': (groupStatus) ? '2px solid #0058ff' : '0px solid blue'}" class="meter-content">
          <div class="d-flex in-group-or-not">
            <div class="nav-item-container">
              <div [hidden]="groupStatus"><embed src="assets/icons/bolt_gray_24dp.svg" class="map-nav-icon"><div class="map-nav-item gray-text">{{'planner.mapNav.notInGroup' | translate }}</div></div>
              <div [hidden]="!groupStatus"><embed src="assets/icons/bolt_blue_24dp.svg" class="map-nav-icon"><div class="map-nav-item gray-text">{{'planner.mapNav.group' | translate }} {{ groupId }}</div></div>
            </div>
          </div>
          <div class="m-c-child">
            <h5 id="meter-id">{{'basic.meter' | translate }} {{ meterId }}</h5>
            <div id="edit-button" class="icon-right" (click)="switchEditMode()">
              <img class="edit-btn" src="assets/icons/edit_gray_24dp.svg">
            </div>
          </div>
          <div class="m-c-child nav-item-container">
            <embed src="assets/icons/location_on_blue_24dp.svg" class="map-nav-icon">
            @if (!editMode) {
              <div class="m-c-child-content edit-input map-nav-item">
                @if (address) {
                  <div class="gray-text">{{ address }}</div>
                }
                @if (!address) {
                  <div class="gray-text">{{'basic.noInformation' | translate }}</div>
                }
              </div>
            }
            @if (editMode) {
              <div><span class="gray-text edit-input">{{'basic.address' | translate }}</span>
              <br>
                <textarea id="edit-address" class="m-c-child-content edit-input form-control" [(ngModel)]="address" (ngModelChange)="onChange($event, 'address')" placeholder="Address">
                </textarea>
              </div>
            }
          </div>
          @for (user of contactList | keyvalue; track user.key; let last = $last) {
            <div id="contact-list" class="m-c-child nav-item-container">
              <embed src="assets/icons/person_blue_24dp.svg" class="map-nav-icon">
              @if (!editMode) {
                <div class="m-c-child-content edit-input gray-text">
                  <span class="blue-text">{{ user.value[0] | translate }}</span>
                  <br>
                    {{ user.value[1] }}
                    <br>
                      {{ user.value[2] }}
                      <br>
                        {{ user.value[3] }}
                        <br>
                          {{ user.value[4] }}
                          @if (!ownerExists && last) {
                            <div>
                              <br>
                                <embed src="assets/icons/person_blue_24dp.svg" class="map-nav-icon margin-left-fix">
                                <span class="blue-text">{{'persontype.0' | translate}}</span><br>
                                <span class="gray-text">{{'basic.noInformation' | translate }}</span>
                              </div>
                            }
                            @if (!residentExists && last) {
                              <div>
                                <br>
                                  <embed src="assets/icons/person_blue_24dp.svg" class="map-nav-icon margin-left-fix">
                                  <span class="blue-text">{{'persontype.2' | translate}}</span><br>
                                  <span class="gray-text">{{'basic.noInformation' | translate }}</span>
                                </div>
                              }
                            </div>
                          }
                          @if (editMode) {
                            <div>
                              <span class="gray-text edit-input">{{'basic.contact' | translate }} ({{ user.value[0] | translate }})</span>
                              <br>
                                <input id="edit-contact-first" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="user.value[1]" (ngModelChange)="onChange($event, 'enduserFirstName')">
                                <input id="edit-contact-last" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="user.value[2]" (ngModelChange)="onChange($event, 'enduserLastName')">
                                <input id="edit-phone" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="user.value[3]" (ngModelChange)="onChange($event, 'enduserNumber')">
                                <input id="edit-address" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="user.value[4]" (ngModelChange)="onChange($event, 'enduserAddress')">
                                @if (!ownerExists && last) {
                                  <div>
                                    <br>
                                      <embed src="assets/icons/person_blue_24dp.svg" class="map-nav-icon">
                                      <span class="gray-text edit-input">{{'basic.contact' | translate}} ({{'persontype.0' | translate}})</span>
                                      <input class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="owner.firstName" (ngModelChange)="onChange($event, null)" placeholder="First name">
                                      <input class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="owner.lastName" (ngModelChange)="onChange($event, null)" placeholder="Last name">
                                      <input class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="owner.phoneNumber" (ngModelChange)="onChange($event, null)" placeholder="Phone number">
                                      <input class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="owner.address" (ngModelChange)="onChange($event, null)" placeholder="Address">
                                    </div>
                                  }
                                  @if (!residentExists && last) {
                                    <div>
                                      <br>
                                        <embed src="assets/icons/person_blue_24dp.svg" class="map-nav-icon">
                                        <span class="gray-text edit-input">{{'basic.contact' | translate}} ({{'persontype.2' | translate}})</span>
                                        <input class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="resident.firstName" (ngModelChange)="onChange($event, null)" placeholder="First name">
                                        <input class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="resident.lastName" (ngModelChange)="onChange($event, null)" placeholder="Last name">
                                        <input class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="resident.phoneNumber" (ngModelChange)="onChange($event, null)" placeholder="Phone number">
                                        <input class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="resident.address" (ngModelChange)="onChange($event, null)" placeholder="Address">
                                      </div>
                                    }
                                  </div>
                                }
                              </div>
                            }
                            @if (contactList.length == 0) {
                              <div>
                                @if (!editMode) {
                                  <div class="m-c-child-content nav-item-container mt-3">
                                    <embed src="assets/icons/person_blue_24dp.svg" class="map-nav-icon">
                                    <div class="edit-input">
                                      <span class="blue-text">{{'persontype.0' | translate}}</span><br>
                                      <span class="gray-text">{{'basic.noInformation' | translate }}</span>
                                    </div>
                                  </div>
                                  <div class="m-c-child-content nav-item-container mt-3">
                                    <embed src="assets/icons/person_blue_24dp.svg" class="map-nav-icon">
                                    <div class="edit-input">
                                      <span class="blue-text">{{'persontype.2' | translate}}</span><br>
                                      <span class="gray-text">{{'basic.noInformation' | translate }}</span>
                                    </div>
                                  </div>
                                }
                                @if (editMode) {
                                  <div>
                                    <embed src="assets/icons/person_blue_24dp.svg" class="map-nav-icon">
                                    <span class="edit-input gray-text">{{'basic.contact' | translate}} ({{'persontype.0' | translate}})</span>
                                    <br>
                                      <input id="owner-first-no-contact" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="owner.firstName" (ngModelChange)="onChange($event, null)" placeholder="First name">
                                      <input id="owner-last-no-contact" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="owner.lastName" (ngModelChange)="onChange($event, null)" placeholder="Last name">
                                      <input id="owner-phone-no-contact" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="owner.phoneNumber" (ngModelChange)="onChange($event, null)" placeholder="Phone number">
                                      <input id="owner-address-no-contact" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="owner.address" (ngModelChange)="onChange($event, null)" placeholder="Address">
                                      <br>
                                        <embed src="assets/icons/person_blue_24dp.svg" class="map-nav-icon">
                                        <span class="edit-input gray-text">{{'basic.contact' | translate}} ({{'persontype.2' | translate}})</span>
                                        <br>
                                          <input id="resident-first-no-contact" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="resident.firstName" (ngModelChange)="onChange($event, null)" placeholder="First name">
                                          <input id="resident-last-no-contact" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="resident.lastName" (ngModelChange)="onChange($event, null)" placeholder="Last name">
                                          <input id="resident-phone-no-contact" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="resident.phoneNumber" (ngModelChange)="onChange($event, null)" placeholder="Phone number">
                                          <input id="resident-address-no-contact" class="m-c-child-content edit-input contact-input form-control" [(ngModel)]="resident.address" (ngModelChange)="onChange($event, null)" placeholder="Address">
                                        </div>
                                      }
                                    </div>
                                  }
                                  <div class="m-c-child nav-item-container">
                                    <embed src="assets/icons/info_blue_24dp.svg" class="map-nav-icon">
                                    @if (!editMode) {
                                      <div class="m-c-child-content map-nav-item gray-text">
                                        @if (notes) {
                                          <span>{{ notes }}</span>
                                        }
                                        @if (!notes) {
                                          <span>{{'basic.noInformation' | translate }}</span>
                                        }
                                      </div>
                                    }
                                    @if (editMode) {
                                      <div><span class="gray-text edit-input">{{'basic.info' | translate }}</span><br>
                                      <textarea id="edit-notes" class="m-c-child-content edit-input form-control" [(ngModel)]="notes" (ngModelChange)="onChange($event, 'notes')">
                                      </textarea>
                                    </div>
                                  }
                                </div>
                                <div class="m-c-child nav-item-container">
                                  <embed src="assets/icons/numbers_blue_24dp.svg" class="map-nav-icon">
                                  @if (!editMode) {
                                    <div class="m-c-child-content map-nav-item gray-text">
                                      @if (locationNumber) {
                                        <div>{{ locationNumber }}</div>
                                      }
                                      @if (!locationNumber) {
                                        <div>{{'basic.noInformation' | translate }}</div>
                                      }
                                    </div>
                                  }
                                  @if (editMode) {
                                    <div><span class="gray-text edit-input">{{'basic.locationNumber' | translate}}</span><br>
                                    <input class="m-c-child-content edit-input form-control" type="text" placeholder="Location number" [(ngModel)]="locationNumber" (ngModelChange)="onChange($event, 'locationNumber')">
                                  </div>
                                }
                              </div>
                              <div class="m-c-child nav-item-container">
                                <embed src="assets/icons/old_meter_icon.svg" class="map-nav-icon">
                                @if (!editMode) {
                                  <div class="m-c-child-content map-nav-item gray-text">
                                    <span class="blue-text">{{'planner.reportWorkorderDetail.oldMeterID' | translate}}</span><br>
                                    @if (oldMeterId) {
                                      <div>{{ oldMeterId }}</div>
                                    }
                                    @if (!oldMeterId) {
                                      <div>{{'basic.noInformation' | translate }}</div>
                                    }
                                  </div>
                                }
                                @if (editMode) {
                                  <div><span class="gray-text edit-input">{{ oldMeterId }}</span><br>
                                  <textarea id="edit-notes" class="m-c-child-content edit-input form-control" [(ngModel)]="notes" (ngModelChange)="onChange($event, 'notes')">
                                  </textarea>
                                </div>
                              }
                            </div>
                            <hr>
                              <div class="m-c-child">
                                <div class="dual-container">
                                  <div class="left dual-container">
                                    <embed src="assets/icons/schedule_blue_24dp.svg" class="map-nav-icon">
                                    <h6 class="map-nav-item fw-600 mb-0 install-time left">{{'basic.installTime' | translate }}</h6>
                                    @if (!editMode) {
                                      <div class="blue-text right order-time">({{singleOrderTime}} min)</div>
                                    }
                                  </div>
                                  @if (!estimateExpand) {
                                    <div (click)="expandEstimates()" class="right time-dropdown"><img class="edit-btn" src="assets/icons/expand_more_black_24dp.svg"></div>
                                  }
                                  @if (estimateExpand) {
                                    <div (click)="expandEstimates()" class="right time-dropdown"><img class="edit-btn" src="assets/icons/expand_less_black_24dp.svg"></div>
                                  }
                                </div>
                              </div>
                              @if (estimateExpand && !editMode) {
                                <div class="map-nav-item estimate-containter">
                                  @for (item of orderTimeEstimate; track $index) {
                                    @if (item.title) {
                                      <div>
                                        <div class="w-100 fw-600 rowtop">{{item.title}}</div>
                                        <div class="dual-container gray-text">
                                          <div class="left install-time">{{item.name}}</div>
                                          @if (item.time) {
                                            <div class="right">({{item.time}} min)</div>
                                          }
                                          @if (!item.time) {
                                            <div class="right red-text">{{'planner.mapNav.noDefault' | translate}}</div>
                                          }
                                        </div>
                                      </div>
                                    }
                                  }
                                </div>
                              }
                              @if (editMode) {
                                <form class="estimate-containter" #f="ngForm" (ngSubmit)="saveChangesToSingleOrder(f)">
                                  @for (item of orderTimeEstimate; track $index; let i = $index) {
                                    <div [attr.data-index]="i" class="mt-3">
                                      @if (item.title) {
                                        <div>
                                          <div class="dual-container gray-text w-100">
                                            <div class="left w-70 primary-name">{{item.title}}</div>
                                            <span class="right text-right w-30">{{'basic.minutes' | translate }}</span>
                                          </div>
                                          <div class="dual-container gray-text w-100">
                                            <div class="w-10">
                                              <button type="button" class="default-setter" (click)="setNull(i)"></button>
                                            </div>
                                            <select class="left install-time form-select w-60 mr-1 ml-1" name="{{ item.categoryid + '-' + item.estimateid }}" [(ngModel)]="item.estimateid">
                                              @for (option of item.options; track $index) {
                                                <option [ngValue]="option.estimateid" [selected]="option.estimateid===item.estimateid">{{ option.name }}</option>
                                              }
                                            </select>
                                            <div class="right row w-30 mr-0 ml-0">
                                              <input class="form-control" value="{{item.time}}" type="number" min="0" placeholder="-" [(ngModel)]="item.time" name="{{ item.categoryid + '_' + item.estimateid }}">
                                            </div>
                                          </div>
                                        </div>
                                      }
                                    </div>
                                  }
                                  <hr>
                                    <div class="map-nav-item">
                                      <h6>{{'basic.overallTime' | translate }}</h6>
                                      <h6 class="blue-text">{{singleOrderTime}} min</h6>
                                    </div>
                                    <button id="save-button" class="btn btn-primary map-btn edit-save-btn" type="submit">{{'basic.save' | translate }}</button>
                                    <button class="btn btn-secondary map-btn edit-save-btn" (click)="cancelEditMode()">{{'basic.cancel' | translate}}</button>
                                  </form>
                                }
                              </div>
                              <div [hidden]="meterId != null" class="meter-content">
                                {{'planner.mapNav.notSelected' | translate }}
                              </div>
                            </div>
                            @if (!editMode) {
                              <div [hidden]="meterId == null || groupping == false" class="selected-child">
                                <button [hidden]="groupStatus" class="btn btn-primary map-btn" (click)="updateOrderClickToParent()">+ {{'planner.mapNav.add' | translate }}</button>
                                <button [hidden]="!groupStatus" class="btn btn-primary map-btn" (click)="updateOrderClickToParent()">- {{'planner.mapNav.remove' | translate }}</button>
                                <div [hidden]="groupStatus">
                                  {{'basic.meter' | translate }} {{ meterId }} > {{'planner.mapNav.group' | translate }} {{ groupId }}
                                </div>
                                <div [hidden]="!groupStatus">
                                  {{'basic.meter' | translate }} {{ meterId }} > {{'planner.mapNav.notInGroup' | translate }}
                                </div>
                              </div>
                            }
                          </div>
                        }
                        <!-- Default mode END -->

                        <!-- MSA mode START -->
                        @if (msaMode) {
                          <div class="pt-3">
                            @if (mapNavSpinner) {
                              <div class="justify-content-center d-flex mt-5">
                                <load-spinner></load-spinner>
                              </div>
                            }
                            @if (!mapNavSpinner) {
                              <div>
                                <div class="align-center ms-4 black-bold-text font-size-large">{{msaTitle}}</div>
                                @if (msaStartDate && msaEndDate) {
                                  <div class="align-center">{{msaStartDate | date: 'dd.MM.yyyy'}} - {{msaEndDate | date: 'dd.MM.yyyy'}}</div>
                                }
                                @if (msaStartDate && !msaEndDate) {
                                  <div class="align-center">{{msaStartDate | date: 'dd.MM.yyyy'}} - <span class="red-text">{{'planner.mapNav.endDateMissing' | translate}}</span></div>
                                }
                                @if (!msaStartDate && msaEndDate) {
                                  <div class="align-center"><span class="red-text">{{'planner.mapNav.startDateMissing' | translate}}</span> - {{msaEndDate | date: 'dd.MM.yyyy'}}</div>
                                }
                                @if (!msaStartDate && !msaEndDate) {
                                  <div class="align-center red-text">{{'planner.mapNav.bothDatesMissing' | translate}}</div>
                                }
                                <div class="align-center black-bold-text mt-2">{{markersInsidePolygon.length}} {{'basic.transformers' | translate | lowercase}} <!--<span class="blue-text">({{totalTimeMarkers}} min)</span>--></div>
                                <div class="align-center gray-text">({{totalMetersCount}} {{'basic.meters' | translate | lowercase}})</div>
                                <div class="gray-text align-center">{{'basic.transformers' | translate }}</div>
                                @for (item of markersInsidePolygon; track $index) {
                                  <div>
                                    <div class="selected-meter selected-child">
                                      <div class="meter-content">
                                        <div>
                                          <div class="black-bold-text">{{'basic.transformer' | translate}} {{item.feature.properties.id}}</div>
                                          <div>
                                            <!--<span class="blue-text">{{item.time}}</span>-->
                                            <span class="gray-text">({{item.workOrdersTotal}} meters)</span>
                                          </div>
                                        </div>
                                        <div class="m-c-child">
                                          <div class="gray-text">{{'planner.mapNav.electricityMeterInstallation' | translate}}</div>
                                        </div>
                                        <div class="m-c-child">
                                          <div class="gray-text">
                                            <div>{{'basic.start' | translate}}:</div>
                                            @if (!item.earliest) {
                                              <div class="red-text">{{'planner.mapNav.dateNotSet' | translate}}</div>
                                            }
                                            @if (item.earliest) {
                                              <div>{{item.earliest | date: 'dd.MM.YYYY'}}</div>
                                            }
                                          </div>
                                          <div class="ms-2 gray-text">
                                            <div>{{'basic.end' | translate}}:</div>
                                            @if (!item.latest) {
                                              <div class="red-text">{{'planner.mapNav.dateNotSet' | translate}}</div>
                                            }
                                            @if (item.latest) {
                                              <div>{{item.latest | date: 'dd.MM.YYYY'}}</div>
                                            }
                                          </div>
                                        </div>
                                        <div class="m-c-child">
                                          <div class="gray-text mb-2">{{item.teams}}</div>
                                        </div>
                                        <button class="btn btn-primary map-btn map-btn-right" (click)="showAllMeters(item.feature.properties.id)"><img src="assets/icons/location_on_white_24dp.svg" class="map-header-icon">{{'mapHeader.showAllMetersBtn' | translate }}</button>
                                      </div>
                                    </div>
                                  </div>
                                }
                                @if (markersInsidePolygon.length == 0) {
                                  <div class="selected-meter selected-child red-text">
                                    <div class="meter-content align-center">{{'planner.mapNav.noTransformers' | translate}}</div>
                                  </div>
                                }
                              </div>
                            }
                            <!-- MSA mode END -->
                          </div>
                        }
